import { AppState } from 'store';

export const helpDeskAttachmentsSelector = ({ helpDesk }: AppState): Record<string, string> => helpDesk?.attachments;
